<template>
  <div class="todo-container pt-3">
    <div v-show="ToDos == ''" class="text">
      <h2>Get started by adding a new ToDo.</h2>
      <p>
        Use the buttons on the right to edit and delete the todos.
        <br>
        Click on the todo to check it done.
      </p>
      <p class="warnings">This is a prototype app. Please do not input any sensitive information!</p>
      <p class="italic">
        Handcrafted with love and care by
        <a href="https://onurusluca.me/">Onur Usluca</a>.
      </p>
    </div>
    <v-row class="addToDo d-flex justify-center">
      <v-col cols="8">
        <v-text-field
          class="addtext"
          label="New ToDo"
          outlined
          v-model="newItem"
          @keyup.enter="addItem"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-btn class="btn" large color="primary" :disabled="newItem == ''" @click="addItem">Add</v-btn>
      </v-col>
    </v-row>

    <transition-group class="d-flex flex-column flex-wrap justify-center align-center" name="fade">
      <v-card
        class="d- justify-center align-center ma-2 text-left"
        v-for="(ToDo, index) in ToDos.slice().reverse()"
        :key="ToDo.id"
        
      >
        <div class="the-list">
          <v-col>
            <li
                       @click="$event.target.classList.toggle('checked')"

              v-if="currentlyEditing !== ToDo.id"
              class="headline listitem mb-1"
            >{{ index + 1}} - {{ ToDo.name }}</li>

            <form v-else class="edit-ToDo-form">
              <label class="edit-ToDo-label">
                Edit:
                <v-text-field type="text" v-model="ToDoEditText" class="edit-ToDo-input"></v-text-field>
              </label>
              <v-btn
                :disabled="ToDoEditText == ''"
                type="submit"
                @click.prevent="updateToDoText()"
              >Save</v-btn>
              <v-btn
                large
                class="closethick"
                icon
                color="secondary"
                @click="currentlyEditing = ToDo"
              >
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </form>
          </v-col>
          <v-col class="tools text-right" v-if="currentlyEditing !== ToDo.id">
            <v-btn large class="dicon" icon color="secondary" @click="editToDo(ToDo)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn large class="dicon" icon color="red" @click="deleteToDo(ToDo.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </div>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { db } from "../firebase/db";

export default {
  name: "ToDoList",
  data() {
    return {
      ToDos: [],
      ToDo: [],
      newItem: "",
      index: "",
      showText: true,
      checked: false,
      currentlyEditing: null,
      ToDoEditText: "",
    };
  },
  methods: {
    async addItem() {
      if (this.newItem) {
        await db.collection("ToDos").add({ name: this.newItem });
        this.newItem = "";
      }
      this.deleteText();
    },
    deleteToDo(id) {
      db.collection("ToDos").doc(id).delete();
    },
    deleteText() {
      this.showText = false;
    },
    editToDo(ToDo) {
      this.currentlyEditing = ToDo.id;
      this.ToDoEditText = ToDo.text;
    },
    async updateToDoText() {
      db.collection("ToDos").doc(this.currentlyEditing).update({
        name: this.ToDoEditText,
      });
      this.currentlyEditing = null;
      this.ToDoEditText = "";
    },
    Check(ToDo) {
  db.collection("ToDos").doc(ToDo.id).patch({ })
}
  },
  beforeDestroy() {
    clearInterval(this.showText);
  },

  firestore: {
    ToDos: db.collection("ToDos"),
  },
};
</script>

<style>
li {
    list-style: none;
    cursor: pointer;
}

.todo-container {
  margin-top: 2rem;
}

.checked {
  text-decoration: line-through;
}

.italic {
  font-style: italic;
}

form {
  margin-left: 2rem;
}

.closethick {
  margin-left: 20px;
}

.text {
  margin: 0 auto;
  margin-top: -200px;
  text-align: center;
  padding: 1vh;
}
.warnings {
  color: red;
}

h2 {
  margin: 0 auto;
  text-align: center;
  margin-top: 30vh;
}
.addToDo {
  position: fixed;
  bottom: -20px;
  right: 0;
  left: -0px;
  padding-right: 30px;
  z-index: 1111;
  background: white;
  box-shadow: 4px 4px 4px 4px #888;
}

.the-list {
  width: max-content;
  min-width: 90vw;
  max-width: 95vw;
}

.dicon {
  padding: 0;
  margin: -20px -2px;
}
</style>